import React from "react";

const ShapePartLeft = ({ color = "#f0f0f0" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="174.999"
            height="427.633"
            viewBox="0 0 174.999 427.633"
        >
            <path
                id="Differenzmenge_137"
                data-name="Differenzmenge 137"
                d="M174,481.1h0l-143.967,0A30.03,30.03,0,0,1,0,451.031L0,278.145a90.249,90.249,0,0,1,16.921-52.609L121.709,79.511a60.028,60.028,0,0,1,48.784-25.048H174V481.1Z"
                transform="translate(0.5 -53.963)"
                fill={color}
                stroke="rgba(0,0,0,0)"
                strokeMiterlimit="10"
                strokeWidth="1"
            />
        </svg>
    );
};

export default ShapePartLeft;
